/**
 * The pack write both pages make, in the browser: `POST /continue/pack` for a pack's nine tiles, one fresh `requestId`
 * per press (`pageVerb.ts` `packContinueBody`). The pack page posts it for a model that is training or ready; the
 * path through the wall posts it for the pack the visitor asked for once their model is queued.
 */
import type {ErrorCode, ErrorResponse} from './contract'
import {packContinueBody} from './pageVerb'
import {mintRequestId} from './requestId'

export type PackContinueResult =
    | {ok: true; batchId: string}
    | {ok: false; status: number; error?: ErrorCode; field?: string}

/** The single photo the visitor asked for on a tile: `POST /continue` on that tile with no words, one `requestId`. */
export async function postTileContinue(tileId: number): Promise<{ok: boolean}> {
    const res = await fetch('/continue', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({basis: {tile: tileId}, direction: '', request_id: mintRequestId()}),
        credentials: 'same-origin',
    })
    return {ok: res.ok}
}

export async function postPackContinue(packSlug: string, direction = ''): Promise<PackContinueResult> {
    const res = await fetch('/continue/pack', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(packContinueBody(packSlug, direction, mintRequestId())),
        credentials: 'same-origin',
    })
    if (!res.ok) {
        let error: ErrorResponse | null = null
        try {
            error = (await res.json()) as ErrorResponse
        } catch {
            // A body-less 4xx/5xx: the status alone names the line.
        }
        return {ok: false, status: res.status, error: error?.error, field: error?.field}
    }
    const data: {batch_id: string} = await res.json()
    return {ok: true, batchId: data.batch_id}
}
